import { render, staticRenderFns } from "./RevenueTypeAdd.vue?vue&type=template&id=4891dbd6&scoped=true&"
import script from "./RevenueTypeAdd.vue?vue&type=script&lang=js&"
export * from "./RevenueTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891dbd6",
  null
  
)

export default component.exports